import React, {useEffect} from 'react';
import { FormPageFieldComponentProps } from 'types/formPage';

import { withFormikFormControl } from '../FormikFormControl';
import {insertRecordFormData, renderTemplate, renderValue} from "../utils";
import {useStore} from "../../@redux";
import {useFormikContext} from "formik";

export type StaticTextProps = FormPageFieldComponentProps;

const StaticText = (props: StaticTextProps) => {
  const { name, value, details, extraConfig = {} } = props
  const { template = {}} = extraConfig
  const {content = '', render_as = ''} = template
  const store = useStore()
  const {
    values,
    setFieldValue,
    setFieldError, errors
  } = useFormikContext();
  const formData = insertRecordFormData( details.instance, null, store, true, false )
  console.log("Static Text Render",render_as, details, content, value, details.form_id, details.instance, formData)
  // return <>{renderValue(value, {render_as: 'markdown',...extraConfig})}</>
  const temp = renderTemplate( content, formData,{render_as: render_as || 'markdown',...extraConfig})
  useEffect( () => {
    if(temp.output !== value){
      console.log('Updating Template Value', name, value, temp.output)
      setFieldValue(name,temp.output)
    }
  }, [temp.output])
  return <>{temp.value}</>
};

export default withFormikFormControl({ value: '' })(StaticText);
